/**
 * LocaleSwitcher provides clickable elements for changing the locale.
 * Supported props: ctx, currentpath, nonTranslated
 */
import React from 'react';
import { navigate } from 'gatsby';
import { changePath } from '../util/localizer';
import locales from '../../content/locales';

export default function LocaleSwitcher(props) {
  const isMultiLingual = Object.keys(locales).length>1;
  const enPath = locales.en.path;
  const esPath = locales.es.path;
  const isPageTranslated = (Array.isArray(props.nonTranslated) ? !props.nonTranslated.includes(props.currentpath) : true);
  // console.log(props.currentpath+' ... Is this page translated?', isPageTranslated?'Y':'N');

  function changeLangHandler(e, targetLang) {
    e.preventDefault();
    // Navigate to locale-specific path
    const newpath = changePath(targetLang, props.currentpath, props.ctx);
    if (newpath) navigate(newpath);
  }

  const handleEsLang = (isPageTranslated ?
    function(e) { changeLangHandler(e, esPath); } : function(e) { navigate(`/`); }
  );

  if (isMultiLingual && isPageTranslated)
    return (
      <div className="block block-locale first last odd" role="complementary" id="block-locale-language">
        <ul className="language-switcher-locale-url">
          <li className="en first active">
            <button key="en" className="language-link active locale-button" onClick={(e) => changeLangHandler(e, enPath)}>English</button>
          </li>
          <li className="es-US last">
            <button key="es" className="language-link locale-button" onClick={handleEsLang}>Espa&#241;ol</button>
          </li>
        </ul>
      </div>
    );
  return null;
};
